import React, { useEffect, useState } from "react";
import "./dashboard.css";
import Sidebar from "./DashboardSidebar";
import ItemsTable from "./ItemsTableDashboard";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { toast } from "react-toastify";
import { appToken, appUser } from "../../../utils/storageHelper";
import { principalApis } from "../../../api/principalApi/Principal";

// small reusable toast + modal helpers (place near other helpers)
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

const notify = (type, title) => {
  // type: 'success'|'error'|'info'|'warning'
  Toast.fire({ icon: type, title });
};

export default function MultiStepWithSidebarBootstrap({ startAt = 0 }) {
  const [currentPage, setCurrentPage] = useState(startAt);
  const pages = [
    { id: 1, title: "NCSC Principals", key: "principals" },
    { id: 2, title: "Category", key: "categories" },
    { id: 3, title: "Metric", key: "metrics" },
    { id: 4, title: "Indicator of Success", key: "indicators" },
  ];

  useEffect(() => {
    setCurrentPage(startAt);
  }, [startAt]);

  // data stores
  const [principals, setPrincipals] = useState([]); // {id, name}
  const [categories, setCategories] = useState([]); // {id, name, principalId}
  const [metrics, setMetrics] = useState([]); // {id, name, categoryId}
  const [indicators, setIndicators] = useState([]); // {id, question, metricId, selfScore, targetScore, notes}

  // generic/simple input
  const [inputValue, setInputValue] = useState("");
  const [alert, setAlert] = useState(null); // {type, msg}

  const [sequenceNo, setSequenceNo] = useState(0);
  // page-specific selection / edit states
  const [selectedPrincipalId, setSelectedPrincipalId] = useState("");
  const [editingCategoryId, setEditingCategoryId] = useState(null);

  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [editingMetricId, setEditingMetricId] = useState(null);

  const [selectedMetricId, setSelectedMetricId] = useState("");
  const [indicatorQuestion, setIndicatorQuestion] = useState("");
  const [indicatorSelf, setIndicatorSelf] = useState("");
  const [indicatorTarget, setIndicatorTarget] = useState("");
  const [indicatorNotes, setIndicatorNotes] = useState("");
  const [editingIndicatorId, setEditingIndicatorId] = useState(null);

  // sidebar collapse state
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  /*  const sidebarWidth = sidebarCollapsed ? 84 : 300; // px */

  /*  const [hydrated, setHydrated] = useState(false); */
  /* const fetchDataNcsc = async () => {
  try {
    const res = await principalApis.getPrincipals();
    if (res.status === 200) {
      const normalized = (res.data.principles || []).map((p) => ({
        id: p.id,
        text: p.text, // display
      }));
      setPrincipals(normalized);
    }
  } catch (err) {
    console.error("Failed to fetch principals:", err);
    toast.error("Failed to load principals");
  }
};

const fetchDataCategory = async () => {
  try {
    const res = await principalApis.getCategory();
    if (res.status === 200) {
      const normalized = (res.data.categories || []).map((c) => ({
        id: c.id,
        text: c.text,
      principalId: c.principle_id ?? c.principal_id ?? c.principalId, // 🔹 convert snake_case → camelCase
      }));
      setCategories(normalized);
    }
  } catch (err) {
    console.error("Failed to fetch categories:", err);
    toast.error("Failed to load categories");
  }
};

const fetchDataMetric = async () => {
  try {
    const res = await principalApis.getMetric();
    if (res.status === 200) {
      const normalized = (res.data.metrics || []).map((m) => {
        const categoryId = m.category_id ?? m.categoryId;
        const category = categories.find(
          (c) => String(c.id) === String(categoryId)
        );

        return {
          id: m.id,
          text: m.text,
          categoryId: category ? String(category.id) : "",   // always string
          principalId: category ? String(category.principalId) : "", // always string
        };
      });
      setMetrics(normalized);
    }
  } catch (err) {
    console.error("Failed to fetch metrics:", err);
    toast.error("Failed to load metrics");
  }
};



const fetchDataIndicator = async () => {
  try {
    const res = await principalApis.getIndicator();
    if (res.status === 200) {
      const normalized = (res.data.indicators || []).map((i) => {
        const metric = metrics.find((m) => String(m.id) === String(i.metric_id));
        const categoryId = metric?.categoryId || "";
        const principalId = metric?.principalId || "";

        return {
          id: i.id,
          question: i.question,
          metricId: String(i.metric_id),
          categoryId,
          principalId,
          selfScore: i.selfScore ?? "-/-",
          targetScore: i.targetScore ?? "-/-",
          notes: i.notes ?? "",
        };
      });
      setIndicators(normalized);
    }
  } catch (err) {
    console.error("Failed to fetch indicators:", err);
    toast.error("Failed to load indicators");
  }
};



   

  useEffect(() => {
    fetchDataNcsc();
  }, []);

  useEffect(() => {
    if(currentPage===1){
         fetchDataCategory();
    }
   
  }, [currentPage]);

  console.log(categories);

   useEffect(() => {
  if (currentPage === 2 && categories.length > 0) {
    fetchDataMetric();
  }
}, [currentPage, categories]);

  console.log(metrics);
  
   useEffect(() => {
  if (currentPage === 3 && metrics.length > 0) {
    fetchDataIndicator();
  }
}, [currentPage, metrics]);


 */

  const fetchAllData = async () => {
    try {
      // 1️⃣ Principals
      const principalsRes = await principalApis.getPrincipals();
      const normalizedPrincipals = (principalsRes.data.principles || []).map(
        (p) => ({
          id: String(p.id),
          text: p.text,
        })
      );
      setPrincipals(normalizedPrincipals);

      // 2️⃣ Categories
      const categoriesRes = await principalApis.getCategory();
      const normalizedCategories = (categoriesRes.data.categories || []).map(
        (c) => ({
          id: String(c.id),
          text: c.text,
          principalId: String(
            c.principle_id ?? c.principal_id ?? c.principalId ?? ""
          ),
        })
      );
      setCategories(normalizedCategories);

      // 3️⃣ Metrics
      const metricsRes = await principalApis.getMetric();
      const normalizedMetrics = (metricsRes.data.metrics || []).map((m) => {
        const categoryId = String(m.category_id ?? m.categoryId);
        const category = normalizedCategories.find((c) => c.id === categoryId);
        return {
          id: String(m.id),
          text: m.text,
          categoryId,
          principalId: category?.principalId ?? "",
          sequence_no: m.sequence_no ?? "",
        };
      });
      setMetrics(normalizedMetrics);

      // 4️⃣ Indicators
      const indicatorsRes = await principalApis.getIndicator();

      console.log("🔍 Raw Indicators API response:", indicatorsRes.data);

      const normalizedIndicators = (indicatorsRes.data.indicators || []).map(
        (i) => {
          const metric = normalizedMetrics.find(
            (m) => m.id === String(i.metric_id)
          );
          return {
            id: String(i.id),
            question: i.question,
            metricId: String(i.metric_id),
            categoryId: metric?.categoryId ?? "",
            principalId: metric?.principalId ?? "",
            targetScore: i.target ?? "-/-",
            notes: i.notes ?? "",
            sequence_no: i.sequence_no ?? "",
          };
        }
      );
      setIndicators(normalizedIndicators);
    } catch (err) {
      console.error("Failed to fetch all data:", err);
      toast.error("Failed to load data");
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const showAlert = (type, msg, timeout = 2200) => {
    setAlert({ type, msg });
    setTimeout(() => setAlert(null), timeout);
  };

  const counts = {
    principals: principals.length,
    categories: categories.length,
    metrics: metrics.length,
    indicators: indicators.length,
  };

  const getState = () => {
    if (currentPage === 0) return principals;
    if (currentPage === 1) return categories;
    if (currentPage === 2) return metrics;
    return indicators;
  };

  /* const getSetter = () => {
    if (currentPage === 0) return setPrincipals;
    if (currentPage === 1) return setCategories;
    if (currentPage === 2) return setMetrics;
    return setIndicators;
  }; */

  // add handlers for each page type
  const handleAdd = async () => {
    // Page 0: principals
    if (currentPage === 0) {
      const text = inputValue.trim();
      if (!text) {
        showAlert("danger", "Enter principal name");
        return;
      }
      try {
        const res = await principalApis.createPrincipal({ text });
        if (res.status === 200) {
          toast.success("Principal added", {
            position: "top-right",
            autoClose: 2000,
          });
          setInputValue("");
          fetchAllData();
        }
      } catch (err) {
        console.error("Failed to add principal:", err);
        toast.error("Failed to add principal");
      }
      return;
    }

    // Page 1: categories
    if (currentPage === 1) {
      const text = inputValue.trim();
      if (!text) {
        showAlert("danger", "Enter category text");
        return;
      }
      try {
        if (editingCategoryId) {
          const res = await principalApis.updateCategory(editingCategoryId, {
            principle_id: selectedPrincipalId,
            text,
          });
          if (res.status === 200) {
            toast.success("Category updated Successfully", {
              position: "top-right",
              autoClose: 2000,
            });
            setEditingCategoryId(null);
            setInputValue("");
            setSelectedPrincipalId("");
            await fetchAllData(); // ✅ always refetch
          }
        } else {
          const res = await principalApis.createCategory({
            principle_id: selectedPrincipalId,
            text,
          });
          if (res.status === 200) {
            toast.success("Category added", {
              position: "top-right",
              autoClose: 2000,
            });
            setInputValue("");
            setSelectedPrincipalId("");
            await fetchAllData(); // ✅ always refetch
          }
        }
      } catch (err) {
        console.error("Failed to add/update category:", err);
        toast.error("Failed to add/update category");
      }
      return;
    }

    // Page 2: metrics
    if (currentPage === 2) {
      const name = inputValue.trim();
      const sequence = sequenceNo;
      if (!name || !sequence) {
        showAlert("danger", "Enter metric name and sequence number");
        return;
      }
      if (!selectedCategoryId) {
        showAlert("danger", "Select a Category");
        return;
      }
      try {
        if (editingMetricId) {
          const res = await principalApis.updateMetric(editingMetricId, {
            category_id: selectedCategoryId,
            text: name,
            sequence_no: Number(sequence),
          });
          if (res.status === 200) {
            toast.success("Metric updated Successfully", {
              position: "top-right",
              autoClose: 2000,
            });
            setEditingMetricId(null);
            setInputValue("");
            setSequenceNo(0);
            setSelectedCategoryId("");
            await fetchAllData();
          }
        } else {
          const res = await principalApis.createMetric({
            category_id: selectedCategoryId,
            text: name,
            sequence_no: Number(sequence),
          });
          if (res.status === 200) {
            toast.success("Metric added", {
              position: "top-right",
              autoClose: 2000,
            });
            setInputValue("");
            setSequenceNo(0);
            setSelectedCategoryId("");
            await fetchAllData();
          }
        }
      } catch (err) {
        console.error("Failed to add/update metric:", err);
        toast.error("Failed to add/update metric");
      }
      return;
    }

    // Page 3: indicators
    if (currentPage === 3) {
      const targetNum = Number(indicatorTarget);
      const sequence = sequenceNo;
      try {
        if (editingIndicatorId) {
          const res = await principalApis.updateIndicator(editingIndicatorId, {
            question: indicatorQuestion.trim(),
            target: targetNum,
            notes: indicatorNotes.trim(),
            metric_id: selectedMetricId,
            sequence_no: Number(sequence),
          });
          if (res.status === 200 || res.status === 204) {
            toast.success("Indicator updated Successfully", {
              position: "top-right",
              autoClose: 2000,
            });
            setEditingIndicatorId(null);
            handelReset();
            await fetchAllData();
          }
        } else {
          const res = await principalApis.createIndicator({
            question: indicatorQuestion.trim(),
            target: targetNum,
            notes: indicatorNotes.trim(),
            metric_id: selectedMetricId,
            sequence_no: Number(sequence),
          });
          if (res.status === 200 || res.status === 201) {
            toast.success("Indicator added", {
              position: "top-right",
              autoClose: 2000,
            });
            handelReset();
            await fetchAllData();
          }
        }
      } catch (err) {
        console.error("Failed to add/update indicator:", err);
        toast.error("Failed to add/update indicator");
      }
      return;
    }
  };

  // for editing page===0 nscs principals only

  const editNcscPrincipal = async (id) => {
    const principal = principals.find((p) => p.id === id);
    console.log(id);

    if (!principal) return;

    const { value: newText } = await Swal.fire({
      title: "Edit Principal",
      input: "text",
      inputLabel: "Principal name",
      inputValue: principal.text,
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
    });

    if (!newText) return; // canceled or empty

    try {
      // ✅ Call API here
      const res = await principalApis.updatePrincipal(id, { text: newText });

      if (res.status === 200) {
        // ✅ Update state so table updates immediately
        setPrincipals((prev) =>
          prev.map((p) => (p.id === id ? { ...p, text: newText } : p))
        );
        toast.success("Principal updated successfully");
      }
    } catch (err) {
      console.error("Failed to update principal:", err);
      toast.error("Failed to update principal");
    }
  };

  const handleEdit = (id) => {
    // Page 0: principals
    if (currentPage === 0) {
      editNcscPrincipal(id);
      return;
    }

    // Page 1: categories
    if (currentPage === 1) {
      const item = categories.find((c) => c.id === id);
      if (!item) return;
      setEditingCategoryId(item.id);
      setInputValue(item.text);
      setSelectedPrincipalId(item.principalId || "");
      /*  Swal.fire({
      icon: "info",
      title: "Editing category",
      text: "Update fields then click Add",
    }); */
      return;
    }

    // Page 2: metrics
    if (currentPage === 2) {
      const item = metrics.find((m) => m.id === id);
      if (!item) return;
      setEditingMetricId(item.id);
      setInputValue(item.text);
      setSequenceNo(item.sequence_no || 0);
      setSelectedCategoryId(item.categoryId.toString() || "");
      const category = categories.find((c) => c.id === item.categoryId);
      setSelectedPrincipalId(category?.principalId?.toString() || "");
      /*  Swal.fire({
      icon: "info",
      title: "Editing metric",
      text: "Update fields then click Add",
    }); */
      return;
    }

    // Page 3: indicators
    if (currentPage === 3) {
      const item = indicators.find((it) => it.id === id);
      if (!item) return;
      setEditingIndicatorId(item.id);
      setIndicatorQuestion(item.question);
      setSelectedMetricId(item.metricId || "");
      const metric = metrics.find((m) => m.id === item.metricId);
      setSelectedCategoryId(metric?.categoryId || "");
      const category = categories.find((c) => c.id === metric?.categoryId);
      setSelectedPrincipalId(category?.principalId || "");
      setIndicatorTarget(String(item.targetScore ?? ""));
      setIndicatorNotes(item.notes || "");
      setSequenceNo(item.sequence_no || 0);
      /*  Swal.fire({
      icon: "info",
      title: "Editing indicator",
      text: "Update fields then click Add",
    }); */
      return;
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will delete the item. This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if (currentPage === 0) {
          principalApis
            .deletePrincipal(id)
            .then((res) => {
              if (res.status === 200) {
                setPrincipals((p) => p.filter((x) => x.id !== id));
                toast.success("Principal deleted successfully");
              }
            })
            .catch((err) => {
              console.error("Failed to delete principal:", err);
              toast.error("Error deleting principal");
            });
        }

        if (currentPage === 1) {
          principalApis
            .deleteCategory(id)
            .then((res) => {
              if (res.status === 200) {
                setCategories((p) => p.filter((x) => x.id !== id));
                toast.success("Category deleted successfully");
              }
            })
            .catch((err) => {
              console.error("Failed to delete category:", err);
              toast.error("Error deleting category");
            });
        }

        if (currentPage === 2) {
          principalApis
            .deleteMetric(id)
            .then((res) => {
              if (res.status === 200) {
                setMetrics((p) => p.filter((x) => x.id !== id));
                toast.success("Metric deleted successfully");
              }
            })
            .catch((err) => {
              console.error("Failed to delete metric:", err);
              toast.error("Error deleting metric");
            });
        }

        if (currentPage === 3) {
          principalApis
            .deleteIndicator(id)
            .then((res) => {
              if (res.status === 200) {
                setIndicators((p) => p.filter((x) => x.id !== id));
                toast.success("Indicator deleted successfully");
              }
            })
            .catch((err) => {
              console.error("Failed to delete indicator:", err);
              toast.error("Error deleting indicator");
            });
        }
      }
    });
  };

  const handleNext = () => {
    // hierarchy check: current page must have at least one row to proceed
    const currentList = getState();
    if (currentList.length === 0) {
      cantProceedWarning(); // uses default message
      return;
    }
    if (currentPage < pages.length - 1) setCurrentPage((p) => p + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 0) setCurrentPage((p) => p - 1);
  };

  /*   const handlePageClick = (index) => {
    // allow navigation back freely; forward only if target page index <= currentPage or current page has data
    if (index > currentPage) {
      // trying to go forward, ensure current has at least one row
      if (getState().length === 0) {
        showAlert(
          "danger",
          "Add at least one item on this page before going forward"
        );
        return;
      }
    }
    setCurrentPage(index);
    setInputValue("");
  };
 */
  /*   const resetAll = () => {
    Swal.fire({
      title: "Clear all data?",
      text: "This will remove principals, categories, metrics and indicators. Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, clear all",
      cancelButtonText: "Cancel",
    }).then((res) => {
      if (res.isConfirmed) {
        // perform reset
        setPrincipals([]);
        setCategories([]);
        setMetrics([]);
        setIndicators([]);
        // reset other state...
        notify("success", "All cleared");
      }
    });
  }; */

  const onKeyDown = (e) => {
    if (e.key === "Enter" && currentPage === 0) handleAdd(); // enter to add principals only
    if (e.key === "Escape") {
      setInputValue("");
      setIndicatorQuestion("");
    }
  };

  // helper lookups
  const findPrincipalName = (id) =>
    principals.find((p) => String(p.id) === String(id))?.text || "";
  const findCategoryName = (id) =>
    categories.find((c) => String(c.id) === String(id))?.text || "";
  const findMetricName = (id) =>
    metrics.find((m) => String(m.id) === String(id))?.text || "";
  const findSequenceNo = (id) =>
    metrics.find((m) => Number(m.id) === Number(id))?.sequence_no || "";

  const cantProceedWarning = (
    msg = "Add at least one item on this page before proceeding"
  ) => {
    Swal.fire({
      icon: "warning",
      title: "Can't proceed",
      text: msg,
    });
  };

  // Edit a metric using API
  const editMetric = async (id, name, categoryId) => {
    try {
      const res = await principalApis.updateMetric(id, {
        category_id: categoryId,
        text: name,
      });
      if (res.status === 200) {
        // Update local state
        setMetrics((prev) =>
          prev.map((m) => (m.id === id ? { ...m, text: name, categoryId } : m))
        );
        notify("success", "Metric updated");
        setEditingMetricId(null);
      }
    } catch (err) {
      console.error("Failed to update metric:", err);
      toast.error("Failed to update metric");
    }
  };

  const handelReset = () => {
    setIndicatorQuestion("");
    setSelectedMetricId("");
    setIndicatorSelf("");
    setIndicatorTarget("");
    setIndicatorNotes("");
    setSequenceNo(0);
    setEditingIndicatorId(null);
  };

  return (
    <div className="container-fluid min-vh-100 bg-light p-0 dashboard-content-offset">
      {/* use flex so main area grows when sidebar width changes */}
      <div className="dashboard-wrapper">
        {/* Sidebar */}
        {/*    <Sidebar
          pages={pages}
          currentPage={currentPage}
          counts={counts}
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
          handlePageClick={handlePageClick}
          className={`dashboard-sidebar ${sidebarCollapsed ? "" : "open"}`}
        />

        {!sidebarCollapsed && window.innerWidth < 768 && (
          <div
            className="sidebar-backdrop"
            onClick={() => setSidebarCollapsed(true)}
          />
        )} */}

        {/* Main */}
        <div
          className="dashboard-content d-flex flex-column"
          // small padding when sidebar is collapsed for visual space
        >
          <div className="card shadow-sm w-100" style={{ minHeight: "680px" }}>
            <div className="card-body d-flex flex-column h-100 p-3">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h4 className="card-title mb-1">
                    {pages[currentPage].title}
                  </h4>
                  <small className="text-muted">
                    {getState().length} item(s)
                  </small>
                </div>
                <div>
                  {/*                   when clear all is needed, uncomment below  */}
                  {/*   <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={resetAll}
                  >
                    Clear All
                  </button> */}
                </div>
              </div>

              {alert && (
                <div
                  className={`alert alert-${alert.type} mt-3 py-2`}
                  role="alert"
                >
                  {alert.msg}
                </div>
              )}

              {/* Page-specific add UIs */}
              {/* Page 0: NCSC Principals */}
              {currentPage === 0 && (
                <div className="row g-2 my-3">
                  <div className="col-12 col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Add NCSC Principal"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={onKeyDown}
                    />
                  </div>
                  <div className="col-12 col-md-auto d-grid d-md-block">
                    <button
                      className="btn btn-success"
                      onClick={handleAdd}
                      disabled={!inputValue.trim()}
                    >
                      Add
                    </button>
                  </div>
                </div>
              )}

              {/* Page 1: Category - dropdown of principals + category name */}
              {currentPage === 1 && (
                <div className="row g-2 align-items-end my-3">
                  <div className="col-12 col-md-4">
                    <label className="form-label small mb-1">
                      NCSC Principal
                    </label>
                    <select
                      className="form-select"
                      value={selectedPrincipalId}
                      onChange={(e) => setSelectedPrincipalId(e.target.value)}
                    >
                      <option value="">-- select principal --</option>
                      {principals.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.text}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 col-md-8">
                    <label className="form-label small mb-1">Category</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Add Category"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                      <button
                        className="btn btn-success"
                        onClick={handleAdd}
                        disabled={!inputValue.trim()}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Page 2: Metric - dropdown of categories + metric name */}
              {currentPage === 2 && (
                <div className="d-flex flex-wrap gap-2 align-items-center my-3">
                  <div style={{ minWidth: 180 }}>
                    <label className="form-label small mb-1">
                      NCSC Principal
                    </label>
                    <select
                      className="form-select"
                      value={selectedPrincipalId}
                      onChange={(e) => {
                        setSelectedPrincipalId(e.target.value);
                        setSelectedCategoryId("");
                      }}
                    >
                      <option value="">-- select principal --</option>
                      {principals.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.text}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={{ minWidth: 240 }}>
                    <label className="form-label small mb-1">Category</label>

                    <select
                      className="form-select"
                      value={selectedCategoryId}
                      onChange={(e) => setSelectedCategoryId(e.target.value)}
                    >
                      <option value="">-- select category --</option>
                      {categories
                        .filter(
                          (c) =>
                            !selectedPrincipalId ||
                            c.principalId?.toString() === selectedPrincipalId
                        )
                        .map((c) => {
                          return (
                            <option key={c.id} value={c.id}>
                              {c.text}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div className="flex-grow-1" style={{ minWidth: 220 }}>
                    <label className="form-label small mb-1">Metric</label>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control me-2"
                        placeholder="Add Metric"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                      {/* <button
                        className="btn btn-success"
                        onClick={handleAdd}
                        disabled={!inputValue.trim()}
                      >
                        Add
                      </button> */}
                    </div>
                  </div>
                  {/* add sequence no here */}

                  <div className="flex-grow-1" style={{ minWidth: 220 }}>
                    <label className="form-label small mb-1">Sequence No</label>
                    <div className="d-flex">
                      <input
                        type="number"
                        className="form-control me-2"
                        placeholder="Add Sequence No"
                        value={sequenceNo}
                        onChange={(e) => setSequenceNo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className=" justify-content-end mt-3">
                    <button
                      className="btn btn-success"
                      onClick={handleAdd}
                      // disabled={!sequenceNo}
                    >
                      Add
                    </button>
                  </div>
                </div>
              )}

              {/* Page 3: Indicator - dropdown of metrics + question + scores + notes */}
              {currentPage === 3 && (
                <div
                  className="border rounded p-3 mb-3"
                  style={{ background: "#fff" }}
                >
                  <div className="row g-2 align-items-end">
                    <div className="col-12 col-md-4">
                      <label className="form-label small mb-1">
                        NCSC Principal
                      </label>
                      <select
                        className="form-select"
                        value={selectedPrincipalId}
                        onChange={(e) => {
                          setSelectedPrincipalId(e.target.value);
                          setSelectedCategoryId("");
                          setSelectedMetricId("");
                        }}
                      >
                        <option value="">-- select principal --</option>
                        {principals.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.text}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label small mb-1">Category</label>
                      <select
                        className="form-select"
                        value={selectedCategoryId}
                        onChange={(e) => {
                          setSelectedCategoryId(e.target.value);
                          setSelectedMetricId("");
                        }}
                      >
                        <option value="">-- select category --</option>
                        {categories
                          .filter(
                            (c) =>
                              !selectedPrincipalId ||
                              c.principalId === selectedPrincipalId
                          )
                          .map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.text}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label small mb-1">Metric</label>
                      <select
                        className="form-select"
                        value={selectedMetricId}
                        onChange={(e) => setSelectedMetricId(e.target.value)}
                      >
                        <option value="">-- select metric --</option>
                        {metrics
                          .filter(
                            (m) =>
                              !selectedCategoryId ||
                              m.categoryId === selectedCategoryId
                          )
                          .map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.text}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-12 col-md-8">
                      <label className="form-label small mb-1">
                        Indicator of Success
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Enter indicator question"
                        rows={3}
                        value={indicatorQuestion}
                        onChange={(e) => setIndicatorQuestion(e.target.value)}
                      />
                    </div>

                    {/*   when you need to add self assesment scores */}
                    {/*  <div className="col-6 col-md-2">
                      <label className="form-label small mb-1">
                        Self assesment
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={indicatorSelf}
                        onChange={(e) => setIndicatorSelf(e.target.value)}
                      />
                    </div> */}

                    <div className="col-6 col-md-2">
                      {/* <label className="form-label small mb-1">
                        Target Score
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={indicatorTarget}
                        onChange={(e) => setIndicatorTarget(e.target.value)}
                        max={5}
                        min={1}
                      /> */}
                    </div>

                    {/* add sequence no here */}

                    <div className="col-12 col-md-8">
                      <label className="form-label small mb-1">
                        Sequence No
                      </label>
                      <div className="d-flex">
                        <input
                          type="number"
                          className="form-control me-2"
                          placeholder="Add Sequence No"
                          value={sequenceNo}
                          onChange={(e) => setSequenceNo(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <label className="form-label small mb-1">Notes</label>
                      <textarea
                        className="form-control"
                        rows={2}
                        value={indicatorNotes}
                        onChange={(e) => setIndicatorNotes(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-3">
                    <button
                      className="btn btn-secondary me-2"
                      onClick={() => handelReset()}
                    >
                      Reset
                    </button>
                    <button className="btn btn-success" onClick={handleAdd}>
                      {editingIndicatorId ? "Save Indicator" : "Add Indicator"}
                    </button>
                  </div>
                </div>
              )}

              {/* Items table / list - replaced by ItemsTable component */}
              <div className="table-responsive">
                <ItemsTable
                  currentPage={currentPage}
                  pages={pages}
                  getState={getState}
                  findPrincipalName={findPrincipalName}
                  findCategoryName={findCategoryName}
                  findMetricName={findMetricName}
                  findSequenceNo={findSequenceNo}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              </div>

              <div className="d-flex justify-content-between flex-wrap gap-2 mt-3">
                <div>
                  {currentPage > 0 && (
                    <button
                      className="btn btn-secondary w-100 w-sm-auto"
                      onClick={handlePrevious}
                    >
                      Previous
                    </button>
                  )}
                </div>
                <div>
                  {currentPage < pages.length - 1 && (
                    <button
                      className="btn btn-primary w-100 w-sm-auto"
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
